<template>
  <div>
    <panel :title="$t('studentScoringComponentEntry.studentList')">
      <ts-loading-banner :loading="loading">
        <div>
          <table class="table table-hover">
            <thead>
              <tr>
                <th>{{ $t('studentScoringComponentEntry.photo') }}</th>
                <th>{{ $t('studentScoringComponentEntry.cardNumber') }}</th>
                <th>{{ $t('studentScoringComponentEntry.studentNameKh') }}</th>
                <th>{{ $t('studentScoringComponentEntry.studentName') }}</th>
                <th>{{ $t('studentScoringComponentEntry.sex') }}</th>
                <th>{{ $t('studentScoringComponentEntry.phoneNumber') }}</th>
                <th style="width: 10px">{{ $t('actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(student, index) in student_list" :key="index">
                <td class="with-img">
                  <img class="height-30 ts-rounded" v-lazy="{
                    src: photoStudent(student.student_profile),
                    error: onError(student.student_profile),
                    loading: require('@/assets/Rolling-1s-200px_2.svg')
                  }" />
                </td>
                <td>{{ student.student_profile.card_number }}</td>
                <td>{{ student.student_profile.full_name_kh }}</td>
                <td>{{ student.student_profile.full_name_en }}</td>
                <td>{{ student.student_profile.gender }}</td>
                <td>{{ student.student_profile.phone }}</td>
                <td class="text-center">
                  <a href="#" class="mr-2 btn btn-xs btn-primary" v-if="allowInput"
                    v-tooltip="$t('studentScoringComponentEntry.entryScore')" @click.prevent="entryScore(student)">
                    <i class="fas fa-pen"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- numeric scoring entry -->
          <a-modal v-if="numeric_scoring" v-model="numeric_scoring" :zIndex="1020" :title="entry_on_student"
            :maskClosable="false" width="500px" :footer="null">
            <numeric-scoring-entry v-model="model" @closeModal="() => (numeric_scoring = false)" />
          </a-modal>
        </div>
      </ts-loading-banner>
    </panel>
  </div>
</template>

<script>
import NumericScoringEntry from './numeric-score-entry'

export default {
  name: 'studentListComponent',
  props: ['value', 'classOperations'],
  components: {
    NumericScoringEntry
  },
  data() {
    return {
      paramsGetComponentForGrading: {
        grade_id: 0,
        sc_bas_id: null
      },
      model: {},
      loading: false,
      numeric_scoring: false,
      grading_scoring: false,
      advisor_comment: false,
      param_props: [],
      student_list: [],
      boyPhoto: require('../../../assets/student-default-boy.png'),
      girlPhoto: require('../../../assets/student-default-girl.png'),
      entry_on_student: 'Unknow'
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    // gradeId () {
    //   return this.classOperations.find(c => c.class_id == this.model.class_id)
    //     .grade_id
    // },
    allowInput() {
      return (
        this.model.class_id !== null &&
        this.model.scoring_cycle_id !== null &&
        this.model.cycle_value !== null &&
        // this.gradeId !== 1 && //grade Pre-nursery
        // this.gradeId !== 2 &&//grade Nursery
        this.model.subject_id !== null
      )
    }
  },
  methods: {
    fetchStudentListHasEnroll(class_id) {
      this.student_list = []
      this.loading = true
      this.$store
        .dispatch(
          'studentScoringComponentEntry/getStudentEnrollmentByClass',
          Object.assign({
            class_id: class_id,
            branch_id: this.$store.state.authUser.default_branch_id
          })
        )
        .then(response => {
          this.student_list = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    photoStudent(record) {
      if (record.photo) {
        return record.photo
      }
      return record.gender == 'Male' ? this.boyPhoto : this.girlPhoto
    },
    onError(record) {
      event
        ? (event.target.src =
          record.gender == 'Male' ? this.boyPhoto : this.girlPhoto)
        : ''
    },
    entryScore(record) {
      var sc_bas_id = 1 // default is item base
      // var scoring_cycle = this.model.scoring_cycle_id

      this.entry_on_student = record.student_profile.full_name_en
      this.model.student_id = record.student_id
      this.model.st_class_id = record.st_class_id

      // entry score for numberic
      this.numeric_scoring = true
      this.model.score_type = 1
      this.model.sc_bas_id = sc_bas_id
    },
    onAdvisorComment(record) {
      this.entry_on_student = record.student_profile.full_name_en
      this.model.student_id = record.student_id
      this.model.st_class_id = record.st_class_id
      this.advisor_comment = true
    }
  },
  watch: {
    'model.class_id': function (id) {
      if (id) {
        this.fetchStudentListHasEnroll(id)
      }
    }
  }
}
</script>
